import { InfiniteData } from '@tanstack/react-query'

import { ListResponse } from '../common/hooks/useInfiniteQuery/useInfiniteQuery.types'

export const mapInfiniteData = <T>(data?: InfiniteData<ListResponse<T>>): InfiniteData<T[]> | undefined => {
  return data
    ? {
        ...data,
        pages: data.pages.map(page => page.data)
      }
    : undefined
}
